import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../styles/root.css";
import aboutImg from "../assets/images/anisija/anisija-logo.svg";
import euLogo from "../assets/images/partners/Eu.png";
import euMkLogo from "../assets/images/partners/EUzaTebe.png";
import grcLogo from "../assets/images/partners/GragjanskiResursenCentar.png";
import socioLogo from "../assets/images/partners/Socio.png";
import { useLocale } from "../context/LocaleContext";

const PARTNERS = [
  { name: "European Union", logo: euLogo },
  { name: "EU Support for Civil Resource Centre", logo: euMkLogo },
  { name: "Граѓански ресурсен центар", logo: grcLogo },
  { name: "Здружение СОЦИО Гостивар", logo: socioLogo },
];

function About() {
  const { t } = useLocale();

  return (
    <div>
      <Navbar />
      <div className="home-container">
        <h1 className="headline">{t.about.headline}</h1>
        <section className="about-panel">
          <div className="about-panel-title">
            <h2>{t.about.title}</h2>
          </div>
          <div className="about-panel-content">
            <div className="about-text">
              {t.about.content.map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
            </div>
            <img
              src={aboutImg}
              alt={t.about.imageAlt}
              className="about-image"
            />
          </div>
        </section>

        <section className="partners-section">
          <h2 className="partners-heading">Нашите партнери</h2>
          <div className="partners-logos">
            {PARTNERS.map((partner) => (
              <div className="partner-card" key={partner.name}>
                <img src={partner.logo} alt={partner.name} />
              </div>
            ))}
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
}

export default About;
